"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuspensionFetchStatus = exports.getAppealState = exports.getCanAppeal = exports.getIsPortalSuspended = void 0;

var _reselect = require("reselect");

var getSuspensionState = function getSuspensionState(state) {
  return state.suspension;
};

var getIsPortalSuspended = (0, _reselect.createSelector)([getSuspensionState], function (suspension) {
  return suspension.get('suspended');
});
exports.getIsPortalSuspended = getIsPortalSuspended;
var getCanAppeal = (0, _reselect.createSelector)([getSuspensionState], function (suspension) {
  return suspension.get('canAppeal');
});
exports.getCanAppeal = getCanAppeal;
var getAppealState = (0, _reselect.createSelector)([getSuspensionState], function (suspension) {
  return suspension.get('appealState');
});
exports.getAppealState = getAppealState;
var getSuspensionFetchStatus = (0, _reselect.createSelector)([getSuspensionState], function (suspension) {
  return suspension.get('fetchStatus');
});
exports.getSuspensionFetchStatus = getSuspensionFetchStatus;